import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation30({ animation, badge, all_animations }: Props) {
  const [spotlightOn, setSpotlightOn] = useState(false)
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setSpotlightOn(true), 300)
    setTimeout(() => setShowBadge(true), 1000)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes spotlightMove {
          0% {
            transform: translateX(-200px) scale(0.5);
            opacity: 0;
          }
          50% {
            transform: translateX(0) scale(1.2);
            opacity: 1;
          }
          100% {
            transform: translateX(0) scale(1);
            opacity: 1;
          }
        }
        @keyframes fadeInUp {
          0% {
            transform: translateY(30px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .spotlight-move {
          animation: spotlightMove 1s ease-out forwards;
        }
        .fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Overlay sombre */}
        <div className={`absolute inset-0 bg-black/50 transition-opacity duration-500 ${spotlightOn ? 'opacity-100' : 'opacity-0'}`} />

        {/* Spotlight cone */}
        <div className={`absolute top-0 w-64 transition-all duration-1000 ${spotlightOn ? 'opacity-100' : 'opacity-0'}`}>
          <div
            className="w-full h-[400px] bg-gradient-to-b from-tessan-yellow/30 via-tessan-yellow/10 to-transparent"
            style={{
              clipPath: 'polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)'
            }}
          />
        </div>

        {/* Badge dans le spotlight */}
        <div className={`relative z-10 ${showBadge ? 'spotlight-move' : 'opacity-0'}`}>
          <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/80">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center relative z-10 ${showBadge ? 'fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.5s' }}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow drop-shadow-lg">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
